export { PageHeading } from './PageHeading';
export type {
  PageHeadingLayout,
  PageHeadingProps,
  PageHeadingSubtitlePlacement,
} from './PageHeading.types';
